import { render, staticRenderFns } from "./SunExpertDoc.vue?vue&type=template&id=0229571c"
import script from "./SunExpertDoc.vue?vue&type=script&lang=js"
export * from "./SunExpertDoc.vue?vue&type=script&lang=js"
import style0 from "./SunExpertDoc.vue?vue&type=style&index=0&id=0229571c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports